/**
 * @file 住所からgoogle mapのリンク先を作成
 */
'use strict'

/**
 * @classname CreateMapLink
 * @classdesc 住所からgoogle mapのリンク先を作成
 */
export default class CreateMapLink {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 * @param {object} controller - controllerオブジェクト
	 */
	constructor($e, controller) {
		console.log('CreateMapLink.constructor')
		this._$e = $e
		this._$buildingAddressInput = $('.input-text-building-address')
		this._$googleIframeInput = $('.input-textarea-google-iframe')
		this._$googleMapLinkInput = $('.input-text-google-map-link')
		this._$e.on('click', (e) => this.onClick(e))
	}

	/**
	 * ファイル変更のコールバック
	 *
	 * @memberof CreateMapLink
	 * @return {undefined}
	 */
	onClick() {
		console.log('CreateMapLink.onClick')
		const val = this._$buildingAddressInput.val()
		const encodeVal = encodeURI(val)
		const mapSrc = `https://maps.google.co.jp/maps?q=${encodeVal}`
		this._$googleMapLinkInput.val(mapSrc)
		this._$googleIframeInput.val(
			`<iframe src="${mapSrc}&output=embed&hl=ja" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`,
		)
	}
}
